import { render, staticRenderFns } from "./classDetails.vue?vue&type=template&id=88d106de&scoped=true"
import script from "./classDetails.vue?vue&type=script&lang=js"
export * from "./classDetails.vue?vue&type=script&lang=js"
import style0 from "./classDetails.vue?vue&type=style&index=0&id=88d106de&prod&lang=less&scoped=true"
import style1 from "./classDetails.vue?vue&type=style&index=1&id=88d106de&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d106de",
  null
  
)

export default component.exports